<template>
  <div>
    <b-row>
      <b-col cols="12">
        <membership-export-form/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import MembershipExportForm from "../../components/membership/MembershipExportForm";
  export default {
    name: 'reports-membership',
    components: {
      MembershipExportForm
    },
  }
</script>
